<template>
  <div>
    <v-container fluid>
      <v-card v-show="!loading_edit">
        <v-app-bar color="primary" flat dark dense>
          <v-toolbar-title>{{ titulo }}</v-toolbar-title>
        </v-app-bar>
        <v-container fluid grid-list-lg>
          <v-row dense>
            <v-col
              cols="12"
              v-if="user.tipo == 'representante' && pedido.fornecedor"
            >
              <!-- fornecedor -->
              <v-card>
                <v-card-title primary-title class="px-4">
                  <v-icon left>person_outline</v-icon>
                  <span class="text-subtitle-1 text-uppercase">Fornecedor</span>
                </v-card-title>
                <v-expand-transition>
                  <v-card-text>
                    <v-row dense>
                      <v-col cols="12" sm="6">
                        <v-text-field
                          label="Razão Social"
                          filled
                          readonly
                          v-model="pedido.fornecedor.razao_social"
                          hide-details
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6">
                        <v-text-field
                          label="Nome Fantasia"
                          filled
                          readonly
                          v-model="pedido.fornecedor.nome_fantasia"
                          hide-details
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row dense>
                      <v-col cols="12" sm="6">
                        <v-text-field
                          label="CNPJ/CPF"
                          filled
                          readonly
                          v-model="pedido.fornecedor.cnpj"
                          hide-details
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6">
                        <v-text-field
                          label="Inscrição Estadual"
                          filled
                          readonly
                          v-model="pedido.fornecedor.ie"
                          hide-details
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row dense>
                      <v-col cols="12" sm="5">
                        <v-text-field
                          label="Rua"
                          filled
                          readonly
                          v-model="pedido.fornecedor.endereco.rua"
                          hide-details
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="2">
                        <v-text-field
                          label="Número"
                          filled
                          readonly
                          v-model="pedido.fornecedor.endereco.numero"
                          hide-details
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="5">
                        <v-text-field
                          label="Bairro"
                          filled
                          readonly
                          v-model="pedido.fornecedor.endereco.bairro"
                          hide-details
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row dense>
                      <v-col cols="12" sm="5">
                        <v-text-field
                          label="Cidade"
                          filled
                          readonly
                          v-model="pedido.fornecedor.endereco.cidade"
                          hide-details
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="4">
                        <v-text-field
                          label="Estado"
                          filled
                          readonly
                          v-model="pedido.fornecedor.endereco.estado"
                          hide-details
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="3">
                        <v-text-field
                          label="CEP"
                          filled
                          readonly
                          v-model="pedido.fornecedor.endereco.cep"
                          hide-details
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row dense>
                      <v-col cols="12" sm="4">
                        <v-text-field
                          label="Email"
                          filled
                          readonly
                          v-model="pedido.fornecedor.endereco.email"
                          hide-details
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="4">
                        <v-text-field
                          label="Telefone"
                          filled
                          readonly
                          v-model="pedido.fornecedor.endereco.telefone"
                          hide-details
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="4">
                        <v-text-field
                          label="Celular"
                          filled
                          readonly
                          v-model="pedido.fornecedor.endereco.celular"
                          hide-details
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-expand-transition>
              </v-card>
            </v-col>

            <v-col cols="12">
              <!-- cliente -->
              <v-card>
                <v-card-title primary-title class="px-4">
                  <v-icon left>mdi-account</v-icon>
                  <span class="text-subtitle-1 text-uppercase">Cliente</span>
                </v-card-title>
                <v-expand-transition>
                  <v-card-text>
                    <v-row dense class="pt-0">
                      <v-col cols="12" sm="2">
                        <v-text-field
                          label="Código"
                          append-icon="search"
                          @click="abrirPesquisaCliente"
                          @click:append="abrirPesquisaCliente"
                          v-model="pedido.cliente.cliente_id"
                          v-if="user.tipo == 'fornecedor'"
                          hide-details
                          background-color="#f8f8f8"
                          filled
                          placeholder=" "
                          persistent-placeholder
                        ></v-text-field>
                        <v-text-field
                          label="Código"
                          v-model="pedido.cliente.cliente_id"
                          v-if="user.tipo == 'representante'"
                          readonly
                          hide-details
                          background-color="#f8f8f8"
                          filled
                          placeholder=" "
                          persistent-placeholder
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="5">
                        <v-text-field
                          label="Razão Social"
                          readonly
                          hide-details
                          v-model="pedido.cliente.razao_social"
                          background-color="#f8f8f8"
                          filled
                          placeholder=" "
                          persistent-placeholder
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="5">
                        <v-text-field
                          label="Nome Fantasia"
                          readonly
                          hide-details
                          v-model="pedido.cliente.nome_fantasia"
                          background-color="#f8f8f8"
                          filled
                          placeholder=" "
                          persistent-placeholder
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row dense>
                      <v-col cols="12" sm="6">
                        <v-text-field
                          label="CNPJ/CPF"
                          readonly
                          hide-details
                          v-model="pedido.cliente.cnpj"
                          background-color="#f8f8f8"
                          filled
                          placeholder=" "
                          persistent-placeholder
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6">
                        <v-text-field
                          label="Representante"
                          readonly
                          hide-details
                          v-model="pedido.cliente.representante_nome"
                          background-color="#f8f8f8"
                          filled
                          placeholder=" "
                          persistent-placeholder
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row dense>
                      <v-col cols="12" sm="5">
                        <v-text-field
                          label="Rua"
                          readonly
                          hide-details
                          v-model="pedido.cliente.endereco.rua"
                          background-color="#f8f8f8"
                          filled
                          placeholder=" "
                          persistent-placeholder
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="2">
                        <v-text-field
                          label="Número"
                          readonly
                          hide-details
                          v-model="pedido.cliente.endereco.numero"
                          background-color="#f8f8f8"
                          filled
                          placeholder=" "
                          persistent-placeholder
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="5">
                        <v-text-field
                          label="Bairro"
                          readonly
                          hide-details
                          v-model="pedido.cliente.endereco.bairro"
                          background-color="#f8f8f8"
                          filled
                          placeholder=" "
                          persistent-placeholder
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row dense>
                      <v-col cols="12" sm="5">
                        <v-text-field
                          label="Cidade"
                          readonly
                          hide-details
                          v-model="pedido.cliente.endereco.cidade"
                          background-color="#f8f8f8"
                          filled
                          placeholder=" "
                          persistent-placeholder
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="4">
                        <v-text-field
                          label="Estado"
                          readonly
                          hide-details
                          v-model="pedido.cliente.endereco.estado"
                          background-color="#f8f8f8"
                          filled
                          placeholder=" "
                          persistent-placeholder
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="3">
                        <v-text-field
                          label="CEP"
                          readonly
                          hide-details
                          v-model="pedido.cliente.endereco.cep"
                          background-color="#f8f8f8"
                          filled
                          placeholder=" "
                          persistent-placeholder
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row v-if="user.tipo == 'representante'" dense>
                      <v-col cols="12" sm="4">
                        <v-text-field
                          label="Email"
                          readonly
                          hide-details
                          v-model="pedido.cliente.endereco.email"
                          background-color="#f8f8f8"
                          filled
                          placeholder=" "
                          persistent-placeholder
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="4">
                        <v-text-field
                          label="Telefone"
                          readonly
                          hide-details
                          v-model="pedido.cliente.endereco.telefone"
                          background-color="#f8f8f8"
                          filled
                          placeholder=" "
                          persistent-placeholder
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="4">
                        <v-text-field
                          label="Celular"
                          readonly
                          hide-details
                          v-model="pedido.cliente.endereco.celular"
                          background-color="#f8f8f8"
                          filled
                          placeholder=" "
                          persistent-placeholder
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-expand-transition>
              </v-card>
            </v-col>

            <v-col cols="12">
              <!-- produtos -->
              <v-card>
                <v-card-title primary-title class="px-4">
                  <v-icon left>mdi-cart</v-icon>
                  <span class="text-subtitle-1 text-uppercase">Produtos</span>
                  <v-spacer />
                  <v-btn
                    depressed
                    color="primary"
                    @click="abrirDialogoProdutos"
                    v-if="user.tipo == 'fornecedor'"
                    >Adicionar Produto</v-btn
                  >
                </v-card-title>
                <v-expand-transition>
                  <v-card-text>
                    <v-row dense class="pt-0">
                      <v-col cols="12">
                        <v-card>
                          <v-data-table
                            :headers="headers"
                            :items="pedido.produtos"
                            hide-default-footer
                            :items-per-page="100"
                          >
                            <template v-slot:item.valor="{ item }">{{
                              item.valor | valorBR
                            }}</template>
                            <template v-slot:item.quantidade="{ item }">{{
                              valorBR(item.quantidade, 0)
                            }}</template>
                            <template v-slot:item.subtotal="{ item }">{{
                              item.subtotal | valorBR
                            }}</template>
                            <template v-slot:item.acoes="{ item }">
                              <v-menu bottom left>
                                <template v-slot:activator="{ on }">
                                  <v-btn icon v-on="on">
                                    <v-icon>more_vert</v-icon>
                                  </v-btn>
                                </template>

                                <v-list dense>
                                  <v-list-item @click="editarProduto(item)">
                                    <v-list-item-title>
                                      <v-icon class="mr-4">edit</v-icon>Editar
                                    </v-list-item-title>
                                  </v-list-item>
                                  <v-list-item
                                    @click="abrirDialogoExcluir(item)"
                                    v-if="user.tipo == 'fornecedor'"
                                  >
                                    <v-list-item-title>
                                      <v-icon class="mr-4">close</v-icon>Excluir
                                    </v-list-item-title>
                                  </v-list-item>
                                </v-list>
                              </v-menu>
                            </template>
                            <template
                              v-slot:body.append
                              v-if="pedido.produtos.length > 0"
                            >
                              <tr>
                                <td></td>
                                <td style="text-align: end">
                                  <v-spacer />
                                  <v-label>Total Geral</v-label>
                                </td>
                                <td style="text-align: center">
                                  <v-chip color="grey lighten-3" label>
                                    <h3>{{ valorBR(quantidadeGeral, 0) }}</h3>
                                  </v-chip>
                                </td>
                                <td></td>
                                <td style="text-align: right">
                                  <v-chip
                                    color="grey lighten-3"
                                    style="transform: translateX(13px)"
                                    label
                                  >
                                    <h3>{{ valorGeral | valorBR }}</h3>
                                  </v-chip>
                                </td>
                                <td></td>
                              </tr>
                            </template>
                          </v-data-table>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-expand-transition>
              </v-card>
            </v-col>

            <v-col cols="12">
              <!-- pagamento -->
              <v-card>
                <v-card-title primary-title class="px-4">
                  <v-icon left>mdi-currency-usd-circle</v-icon>
                  <span class="text-subtitle-1 text-uppercase">Pagamento</span>
                </v-card-title>
                <v-expand-transition>
                  <v-card-text>
                    <v-form ref="form" v-model="form_valid">
                      <v-row dense>
                        <v-col cols="12" sm="3">
                          <as-date-picker-menu
                            label="Data do Pedido"
                            v-model="pedido.data"
                            ref="data"
                            readonly
                            :rules="rules.data"
                            background-color="#f8f8f8"
                            filled
                            placeholder=" "
                            persistent-placeholder
                            hideDetails
                          ></as-date-picker-menu>
                        </v-col>
                        <v-col cols="12" sm="3">
                          <as-date-picker-menu
                            label="Entrega"
                            v-model="pedido.entrega"
                            ref="entrega"
                            @keydown.native.enter="
                              $refs.desconto_percentual.focus()
                            "
                            :min="data_atual"
                            :rules="rules.entrega"
                            background-color="#f8f8f8"
                            filled
                            placeholder=" "
                            persistent-placeholder
                            hideDetails
                          ></as-date-picker-menu>
                        </v-col>
                        <v-col cols="12" sm="3">
                          <as-campo-valor
                            label="Desconto %"
                            v-model="pedido.desconto_percentual"
                            ref="desconto_percentual"
                            @keydown.native.enter="$refs.desconto_valor.focus()"
                            @keyup.native="calcularDescontoValor"
                            :rules="rules.valor_zerado"
                            :readonly="user.tipo == 'representante'"
                            background-color="#f8f8f8"
                            filled
                            placeholder=" "
                            persistent-placeholder
                            hideDetails
                          ></as-campo-valor>
                        </v-col>
                        <v-col cols="12" sm="3">
                          <as-campo-valor
                            label="Desconto Valor"
                            v-model="pedido.desconto_valor"
                            ref="desconto_valor"
                            @keydown.native.enter="
                              $refs.comissao_percentual.focus()
                            "
                            @keyup.native="calcularDescontoPercentual"
                            :rules="rules.valor_zerado"
                            :readonly="user.tipo == 'representante'"
                            background-color="#f8f8f8"
                            filled
                            placeholder=" "
                            persistent-placeholder
                            hideDetails
                          ></as-campo-valor>
                        </v-col>
                      </v-row>
                      <v-row dense>
                        <v-col cols="12" sm="2">
                          <as-campo-valor
                            label="Comissão %"
                            v-model="pedido.comissao_percentual"
                            ref="comissao_percentual"
                            @keydown.native.enter="$refs.comissao_valor.focus()"
                            readonly
                            background-color="#f8f8f8"
                            filled
                            placeholder=" "
                            persistent-placeholder
                            hideDetails
                          ></as-campo-valor>
                        </v-col>
                        <v-col cols="12" sm="2">
                          <as-campo-valor
                            label="Comissão Valor"
                            v-model="pedido.comissao_valor"
                            ref="comissao_valor"
                            @keydown.native.enter="$refs.comissao_tipo.focus()"
                            readonly
                            background-color="#f8f8f8"
                            filled
                            placeholder=" "
                            persistent-placeholder
                            hideDetails
                          ></as-campo-valor>
                        </v-col>
                        <v-col cols="12" sm="2">
                          <v-select
                            label="Comissão Tipo"
                            v-model="pedido.comissao_tipo"
                            :items="comissao_tipo"
                            ref="comissao_tipo"
                            @keydown.native.enter="
                              $refs.forma_pagamento.focus()
                            "
                            readonly
                            background-color="#f8f8f8"
                            filled
                            placeholder=" "
                            persistent-placeholder
                            hideDetails
                          ></v-select>
                        </v-col>
                        <v-col cols="12" sm="3">
                          <v-select
                            label="Forma de Pagamento"
                            v-model="pedido.forma_pagamento"
                            :items="formas_pagamento"
                            ref="forma_pagamento"
                            @keydown.native.enter="$refs.prazo.focus()"
                            :rules="rules.forma_pagamento"
                            background-color="#f8f8f8"
                            filled
                            placeholder=" "
                            persistent-placeholder
                            hideDetails
                          ></v-select>
                        </v-col>
                        <v-col cols="12" sm="3">
                          <v-combobox
                            v-model="pedido.prazo"
                            :items="prazos"
                            label="Prazo de Pagamento"
                            ref="prazo"
                            @keydown.native.enter="$refs.transportadora.focus()"
                            :rules="rules.prazo"
                            background-color="#f8f8f8"
                            filled
                            placeholder=" "
                            persistent-placeholder
                            hideDetails
                          ></v-combobox>
                        </v-col>
                      </v-row>
                      <v-row dense>
                        <v-col cols="12" sm="3">
                          <v-text-field
                            label="Transportadora"
                            v-model="pedido.transportadora"
                            ref="transportadora"
                            @keydown.native.enter="
                              $refs.transportadora_telefone.focus()
                            "
                            background-color="#f8f8f8"
                            filled
                            placeholder=" "
                            persistent-placeholder
                            hideDetails
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="3">
                          <v-text-field
                            label="Transportadora Telefone"
                            v-model="pedido.transportadora_telefone"
                            ref="transportadora_telefone"
                            v-mask="
                              (pedido.transportadora_telefone || '').replace(
                                /\D/g,
                                ''
                              ).length <= 10
                                ? '(##) ####-####'
                                : '(##) #####-####'
                            "
                            :return-masked-value="true"
                            @keydown.native.enter="$refs.vendedor.focus()"
                            background-color="#f8f8f8"
                            filled
                            placeholder=" "
                            persistent-placeholder
                            hideDetails
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="2">
                          <v-text-field
                            label="Vendedor"
                            v-model="pedido.vendedor"
                            ref="vendedor"
                            @keydown.native.enter="$refs.valor_bruto.focus()"
                            :rules="rules.vendedor"
                            background-color="#f8f8f8"
                            filled
                            placeholder=" "
                            persistent-placeholder
                            hideDetails
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="2">
                          <as-campo-valor
                            label="Valor Bruto"
                            v-model="pedido.valor_bruto"
                            ref="valor_bruto"
                            @keydown.native.enter="$refs.valor_liquido.focus()"
                            readonly
                            background-color="#f8f8f8"
                            filled
                            placeholder=" "
                            persistent-placeholder
                            hideDetails
                          ></as-campo-valor>
                        </v-col>
                        <v-col cols="12" sm="2">
                          <as-campo-valor
                            label="Valor Líquido"
                            v-model="pedido.valor_liquido"
                            ref="valor_liquido"
                            @keydown.native.enter="$refs.observacoes.focus()"
                            readonly
                            background-color="#f8f8f8"
                            filled
                            placeholder=" "
                            persistent-placeholder
                            hideDetails
                          ></as-campo-valor>
                        </v-col>
                      </v-row>
                      <v-row dense>
                        <v-col cols="12" sm="12">
                          <v-textarea
                            label="Observações"
                            v-model="pedido.observacoes"
                            ref="observacoes"
                            background-color="#f8f8f8"
                            filled
                            placeholder=" "
                            persistent-placeholder
                            hideDetails
                          ></v-textarea>
                        </v-col>
                      </v-row>
                      <v-row dense class="pa-1 pt-4">
                        <v-spacer></v-spacer>
                        <v-btn
                          depressed
                          class="mr-4"
                          @click="cancelarPedido"
                          :disabled="loading"
                          >Cancelar</v-btn
                        >
                        <v-btn
                          depressed
                          color="primary"
                          @click="salvarPedido"
                          :disabled="salvarDisabled"
                          :loading="loading"
                          >Salvar Pedido</v-btn
                        >
                      </v-row>
                    </v-form>
                  </v-card-text>
                </v-expand-transition>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-card>

      <as-dialogo
        ref="dialogoProdutos"
        title="Selecionar Produto"
        max-width="1200px"
        semPadding
        hideDivider
        hideCloseButton
      >
        <v-container fluid class="pa-4 pb-0">
          <v-form ref="form_produto" v-model="form_valid_produto">
            <v-row dense>
              <v-col cols="12" sm="2">
                <v-text-field
                  label="Código"
                  v-model="produto.codigo"
                  append-icon="search"
                  @keydown.native.enter="pesquisarProdutoCodigo"
                  @click:append="abrirPesquisaProduto"
                  :error-messages="erro_produto"
                  ref="produto_codigo"
                  background-color="#f8f8f8"
                  :readonly="user.tipo != 'fornecedor'"
                  filled
                  placeholder=" "
                  persistent-placeholder
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="8">
                <v-text-field
                  label="Descrição"
                  v-model="produto.descricao"
                  readonly
                  background-color="#f8f8f8"
                  filled
                  placeholder=" "
                  persistent-placeholder
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="2">
                <as-campo-valor
                  label="Valor"
                  v-model="produto.valor"
                  ref="produto_valor"
                  @keydown.native.enter="$refs['0_0'][0].focus()"
                  :rules="rules.valor_positivo"
                  background-color="#f8f8f8"
                  filled
                  placeholder=" "
                  persistent-placeholder
                ></as-campo-valor>
              </v-col>
            </v-row>
          </v-form>
          <v-row
            dense
            v-if="produto.tamanhos.length > 0 || produto.cores.length > 0"
          >
            <v-col cols="12" class="px-1 pt-1">
              <v-card
                v-show="produto.tamanhos && produto.cores"
                class="tabela"
                width="inherit"
              >
                <div class="zui-wrapper">
                  <div class="zui-scroller pa-0">
                    <table
                      class="v-datatable v-table theme--light zui-table"
                      style="border-radius: 4px"
                    >
                      <thead style="border-radius: 4px">
                        <tr style="border-radius: 4px">
                          <th
                            class="zui-sticky-col primary lighten-1 pa-4"
                            style="border-radius: 4px 0px 0px 0px; color: white !important; font-weight: 600; width: 100%"
                          >
                            CORES
                          </th>
                          <th
                            v-for="(tamanho, index) in produto.grade[0]
                              .tamanhos"
                            v-bind:key="tamanho.id"
                            class="primary lighten-2"
                            :style="
                              index === produto.grade[0].tamanhos.length - 1 &&
                              index > 8
                                ? 'color: white !important; font-weight: 600; border-radius: 0px 4px 0px 0px; width: 100%'
                                : 'color: white !important; font-weight: 600; width: 100%'
                            "
                          >
                            {{ tamanho.tamanho_nome }}
                          </th>
                          <template
                            v-if="produto.grade[0].tamanhos.length <= 8"
                          >
                            <th
                              v-for="n in 8 - produto.grade[0].tamanhos.length"
                              v-bind:key="n"
                              :style="
                                n === 8 - produto.grade[0].tamanhos.length
                                  ? 'border-radius: 0px 4px 0px 0px; width: 100%'
                                  : 'width: 100%'
                              "
                            ></th>
                          </template>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(grade, indice_grade) in produto.grade"
                          v-bind:key="indice_grade"
                        >
                          <td class="zui-sticky-col">{{ grade.cor_nome }}</td>
                          <td
                            v-for="(tamanho, indice_tamanho) in grade.tamanhos"
                            v-bind:key="indice_tamanho"
                            style="padding: 0px;"
                          >
                            <input
                              type="number"
                              v-model="tamanho.quantidade"
                              min="0"
                              :ref="
                                indice_grade.toString() +
                                  '_' +
                                  indice_tamanho.toString()
                              "
                              @keydown.enter="
                                setFocusGrade(
                                  indice_grade.toString() +
                                    '_' +
                                    indice_tamanho.toString()
                                )
                              "
                              style="height: 100%; width: 100%; text-align: center; outline: none; font-size: 16px;"
                            />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </v-card>
            </v-col>
          </v-row>
        </v-container>

        <div slot="botoes_esquerda">
          <v-btn v-if="produto.id" @click="abrirDialogoObservacoes" depressed
            >Observações</v-btn
          >
        </div>
        <div slot="botoes">
          <v-btn depressed @click="fecharDialogoProdutos">Cancelar</v-btn>
          <v-btn
            depressed
            class="ml-4"
            color="primary"
            @click="salvarProduto"
            ref="salvar_produto"
            :disabled="!form_valid_produto"
            >Salvar</v-btn
          >
        </div>
      </as-dialogo>

      <busca-clientes
        ref="dialogoPesquisaCliente"
        @selecionouCliente="selecionarCliente"
      ></busca-clientes>

      <as-dialogo
        ref="dialogoPesquisaProduto"
        title="Buscar Produto"
        max-width="1000px"
        semPadding
      >
        <div slot="busca">
          <v-container grid-list-xs fluid>
            <v-row dense>
              <v-col cols="12">
                <v-text-field
                  label="Buscar Produto"
                  append-icon="search"
                  @click:append="pesquisarProduto"
                  @keydown.native.enter="pesquisarProduto"
                  v-model="busca_produto"
                  autofocus
                  placeholder="Digite o código ou a descrição"
                  ref="busca_produtos"
                  hide-details
                  solo
                  background-color="grey lighten-2"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </div>

        <v-container fluid pa-4 pt-0>
          <v-data-table
            :headers="headers_produtos"
            :items="produtos"
            @click:row="(produto) => selecionarProduto(produto)"
            class="row-pointerPedido"
            item-key="id"
            :footer-props="{
              itemsPerPageOptions: [30, 50, 10, { text: 'Todos', value: -1 }],
              itemsPerPageText: 'Registros Exibidos',
            }"
            :search="busca_produto"
            :custom-filter="filtrarProdutos"
          >
            <template v-slot:item.valor="{ item }">{{
              item.valor | valorBR
            }}</template>
          </v-data-table>
          <v-layout
            v-show="loading_busca_produtos"
            class="justify-center align-center my-5"
          >
            <v-progress-circular
              indeterminate
              size="50"
              width="3"
              color="primary"
            ></v-progress-circular>
          </v-layout>
        </v-container>
      </as-dialogo>

      <as-dialogo
        ref="dialogoExcluirProduto"
        title="Excluir Produto"
        max-width="520px"
        hideCloseButton
        hideDivider
      >
        <v-label
          >Tem certeza que deseja excluir esse produto deste pedido?</v-label
        >
        <div slot="botoes">
          <v-btn depressed class="mr-4" @click="fecharDialogoExcluir"
            >Cancelar</v-btn
          >
          <v-btn depressed color="error" @click="excluirProduto">Excluir</v-btn>
        </div>
      </as-dialogo>

      <as-dialogo
        ref="dialogoObservacoes"
        title="Observações do Produto"
        max-width="600px"
        hideCloseButton
        hideDivider
      >
        <v-textarea
          filled
          v-model="produto.observacoes"
          ref="observacao_produto"
          name
          label="Observações"
          rows="4"
          auto-grow
          hideDetails
          placeholder="Digite aqui as observações referentes a esse produto"
          persistent-placeholder
        ></v-textarea>
        <div slot="botoes" class="pt0">
          <v-btn
            depressed
            class="mr-4"
            @click="$refs.dialogoObservacoes.fechar()"
            >Cancelar</v-btn
          >
          <v-btn
            depressed
            color="primary"
            @click="$refs.dialogoObservacoes.fechar()"
            >Salvar</v-btn
          >
        </div>
      </as-dialogo>

      <as-dialogo
        ref="dialogoPedidoAberto"
        title="Recuperar Pedido"
        max-width="520px"
        hideCloseButton
        hideDivider
      >
        <v-label
          >Há um pedido que não foi finalizado. Deseja recuperá-lo?</v-label
        >
        <div slot="botoes">
          <v-btn depressed @click="cancelarRecuperacaoPedido">Cancelar</v-btn>
          <v-btn depressed class="ml-4" color="primary" @click="recuperarPedido"
            >Recuperar</v-btn
          >
        </div>
      </as-dialogo>

      <v-layout v-show="loading_edit" class="justify-center align-center mt-5">
        <v-progress-circular
          indeterminate
          size="50"
          width="3"
          color="primary"
        ></v-progress-circular>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import moment from "moment";
import { v4 as uuidv4 } from "uuid";

import ServicePedidos from "@/services/pedidos.js";
import BuscaClientes from "@/views/clientes/BuscaClientes";
import { loadPedidoFromCache } from "@/plugins/offline";

const pedidoBlank = {
  data: "",
  entrega: "",
  desconto_percentual: 0,
  desconto_valor: 0,
  taxa_percentual: 0,
  taxa_valor: 0,
  comissao_percentual: 5,
  comissao_valor: 0,
  comissao_tipo: "Fornecedor",
  forma_pagamento: "",
  prazo: "",
  transportadora: "",
  transportadora_telefone: "",
  vendedor: "",
  valor_bruto: 0,
  valor_liquido: 0,
  observacoes: "",
  cliente: {
    id: "",
    razao_social: "",
    nome_fantasia: "",
    cnpj: "",
    endereco: {
      rua: "",
      numero: "",
      bairro: "",
      cidade: "",
      estado: "",
      cep: "",
    },
  },
  produtos: [],
};

export default {
  name: "PedidosForm",
  components: {
    BuscaClientes,
  },
  data() {
    return {
      hoje: moment().format("YYYY-MM-DD"),
      loading: false,
      loading_edit: false,
      loading_busca_clientes: false,
      user: {},
      rodada: {},
      busca_cliente: "",
      clientes: [],
      pedido: JSON.parse(JSON.stringify(pedidoBlank)),
      busca_produto: "",
      produtos: [],
      produto: {
        tamanhos: [],
        cores: [],
        observacoes: "",
        valor: "",
      },
      loading_busca_produtos: false,
      erro_produto: "",
      headers: [
        {
          text: "Código",
          value: "codigo",
          width: "5%",
          align: "center",
          sortable: false,
        },
        {
          text: "Descrição",
          value: "descricao",
          width: "60%",
          align: "left",
          sortable: false,
        },
        {
          text: "Quantidade",
          value: "quantidade",
          width: "10%",
          align: "center",
          sortable: false,
        },
        {
          text: "Preço",
          value: "valor",
          width: "10%",
          align: "center",
          sortable: false,
        },
        {
          text: "SubTotal",
          value: "subtotal",
          width: "10%",
          align: "right",
          sortable: false,
        },
        {
          text: "",
          value: "acoes",
          width: "5%",
          align: "center",
          sortable: false,
        },
      ],
      headers_loja: [
        {
          text: "Nome Fantasia",
          value: "nome_fantasia",
          width: "30%",
          align: "left",
          sortable: false,
        },
        {
          text: "Razão Social",
          value: "razao_social",
          width: "35%",
          align: "left",
          sortable: false,
        },
        {
          text: "CNPJ",
          value: "cnpj",
          width: "30%",
          align: "center",
          sortable: false,
        },
        {
          text: "Local",
          value: "local",
          width: "5%",
          align: "right",
          sortable: false,
        },
      ],
      headers_clientes: [
        {
          text: "Código",
          value: "id",
          width: "5%",
          align: "left",
          sortable: true,
        },
        {
          text: "Empresa",
          value: "nome",
          width: "60%",
          align: "left",
          sortable: true,
        },
        {
          text: "Responsável",
          value: "responsavel_nome",
          width: "30%",
          align: "left",
          sortable: true,
        },
        {
          text: "",
          value: "data-table-expand",
          width: "5%",
          align: "left",
          sortable: false,
        },
      ],
      headers_produtos: [
        {
          text: "Código",
          value: "codigo",
          width: "15%",
          align: "left",
          sortable: true,
        },
        {
          text: "Descrição",
          value: "descricao",
          width: "70%",
          align: "left",
          sortable: true,
        },
        {
          text: "Valor",
          value: "valor",
          width: "15%",
          align: "right",
          sortable: true,
        },
      ],
      produto_index: -1,
      comissao_tipo: ["Fornecedor"],
      formas_pagamento: [
        "À Vista",
        "Depósito",
        "Transferência",
        "Cheque",
        "Cartão de Crédito",
        "Cartão de Débito",
        "Boleto",
        "PIX",
        "Duplicata",
      ],
      data_atual: "",
      form_valid: true,
      form_valid_produto: false,
      rules: {
        data: [(value) => !!value || "Obrigatório"],
        entrega: [(value) => !!value || "Obrigatório"],
        forma_pagamento: [(value) => !!value || "Obrigatório"],
        prazo: [(value) => !!value || "Obrigatório"],
        vendedor: [(value) => !!value || "Obrigatório"],
        valor_zerado: [
          (value) =>
            parseFloat(value.replace(",", ".")) >= 0 ||
            "O valor não pode ser negativo",
        ],
        valor_positivo: [
          (value) =>
            (!!value && parseFloat(value.replace(",", ".")) > 0) ||
            "O valor não pode ser zero ou negativo",
        ],
      },
      prazos: [
        "15",
        "15/30",
        "15/30/45",
        "15/30/45/60",
        "15/30/45/60/75",
        "30",
        "30/60",
        "30/60/90",
        "30/60/90/120",
        "30/60/90/120/150",
        "60",
        "60/90",
        "60/90/120",
        "60/90/120/150",
      ],
      expanded: [],
    };
  },
  mounted() {
    this.pedido = JSON.parse(JSON.stringify(pedidoBlank));

    this.user = JSON.parse(localStorage.getItem("user"));
    this.rodada = JSON.parse(localStorage.getItem("rodada"));

    if (
      this.$store.state.rodadaSetada &&
      (this.rodada.permitir_pedidos == false ||
        typeof this.rodada.permitir_pedidos == "undefined")
    ) {
      this.$router.push("/pedidos");
    }

    this.getDataAtual();

    if (!this.$route.params.id) {
      if (JSON.parse(localStorage.getItem("pedido"))) {
        this.$refs.dialogoPedidoAberto.abrir();
      }
    }

    if (this.$route.params.id) {
      this.editar(
        this.$route.params.id,
        this.$route.query.uuid || this.$route.params.id
      );
    }

    if (this.$route.meta.status == "novo") {
      this.pedido.uuid = uuidv4();
      this.pedido.rodada_id = this.rodada.id;
    }

    if (this.user.tipo == "representante") {
      this.rules.vendedor = [];
    }
  },
  methods: {
    filtrarProdutos(value, query, item) {
      if (!query) return true;

      return [
        item.codigo,
        item.descricao,
        new Intl.NumberFormat("id", { minimumFractionDigits: 2 }).format(
          item.valor
        ),
      ]
        .join("|")
        .toLocaleLowerCase()
        .includes(query.toLocaleLowerCase());
    },
    abrirPesquisaCliente() {
      this.$refs.dialogoPesquisaCliente.abrir();
    },
    selecionarCliente(cliente) {
      this.pedido.cliente = this.clone(cliente);
    },
    abrirDialogoProdutos() {
      this.$refs.dialogoProdutos.abrir();
      this.pesquisarProduto();
      setTimeout(() => {
        this.$refs.produto_codigo.focus();
      }, 500);
    },
    abrirPesquisaProduto() {
      this.$refs.dialogoPesquisaProduto.abrir();

      setTimeout(() => {
        this.$refs.busca_produtos.focus();
      }, 500);
    },
    async pesquisarProduto() {
      try {
        this.loading_busca_produtos = true;
        ServicePedidos.getProdutos("").then(({ data }) => {
          this.produtos = data.produtos;
        });
      } catch (error) {
        this.$eventbus.erro("Erro ao fazer busca de produtos", error);
      } finally {
        this.loading_busca_produtos = false;
      }
    },
    selecionarProduto(produto_selecionado) {
      this.erro_produto = "";

      this.produto_index = this.pedido.produtos.findIndex(
        (item) => item.codigo === produto_selecionado.codigo
      );

      if (this.produto_index >= 0) {
        this.produto = this.clone(this.pedido.produtos[this.produto_index]);
        this.$refs.dialogoPesquisaProduto.fechar();
        this.$refs.produto_valor.focus();
      } else {
        this.produto = this.clone(produto_selecionado);
        this.$refs.dialogoPesquisaProduto.fechar();
        this.$refs.produto_valor.focus();
      }
    },
    async pesquisarProdutoCodigo() {
      this.produto_index = this.pedido.produtos.findIndex(
        (item) => item.codigo === this.produto.codigo
      );

      if (this.produto_index >= 0) {
        this.produto = this.clone(this.pedido.produtos[this.produto_index]);
        this.$refs.produto_valor.focus();
      } else {
        this.erro_produto = "";
        try {
          if (this.produto.codigo) {
            const produto = this.produtos.find(
              (pro) => pro.codigo === this.produto.codigo
            );

            if (produto) {
              this.produto = Object.assign({}, produto);
              this.$refs.produto_valor.focus();
            } else {
              this.produto = {
                tamanhos: [],
                cores: [],
                observacoes: "",
                valor: 0,
              };
              this.erro_produto = "Código não encontrado";
              this.$eventbus.erro("Código não encontrado");
            }
          } else {
            this.$refs.dialogoPesquisaProduto.abrir();
          }
        } catch (error) {
          this.$eventbus.erro("Erro ao buscar produto", error);
        }
      }
    },
    setFocusGrade(ref) {
      let cor_indice = parseInt(ref.split("_")[0]);
      let tamanho_indice = parseInt(ref.split("_")[1]);

      if (
        tamanho_indice + 1 == this.produto.tamanhos.length &&
        cor_indice + 1 == this.produto.cores.length
      ) {
        this.salvarProduto();
      } else {
        if (tamanho_indice + 1 == this.produto.tamanhos.length) {
          tamanho_indice = 0;
          cor_indice += 1;
        } else {
          tamanho_indice += 1;
        }

        let proximo_ref =
          cor_indice.toString() + "_" + tamanho_indice.toString();

        this.$refs[proximo_ref][0].focus();
      }
    },
    salvarProduto() {
      if (this.$refs.form_produto.validate()) {
        this.totalizarQuantidadeProduto(this.produto);

        if (this.produto.quantidade > 0) {
          if (this.produto_index > -1) {
            this.pedido.produtos.splice(this.produto_index, 1, this.produto);
          } else {
            this.pedido.produtos.unshift(this.produto);
          }

          this.pedido.quantidade = this.quantidadeGeral;
          this.pedido.valor_bruto = this.valorGeral;
          this.calcularValorLiquido();
          this.calcularDescontoValor();
          this.calcularTaxaValor();
          this.$refs.dialogoProdutos.fechar();
          this.produto_index = -1;
          this.produto = {
            tamanhos: [],
            cores: [],
            observacoes: "",
            valor: 0,
          };
        } else {
          this.$eventbus.erro(
            "A quantidade do produto não pode ser zero ou negativa"
          );
        }
      }
    },
    totalizarQuantidadeProduto(produto) {
      let qtd_geral = 0;
      this.produto.grade.forEach((cor) => {
        let qtd_cor = cor.tamanhos.reduce((soma, tamanho) => {
          if (tamanho.quantidade > 0) {
            return soma + parseFloat(tamanho.quantidade);
          } else {
            tamanho.quantidade = 0;
            return soma + 0;
          }
        }, 0);
        qtd_geral += qtd_cor;
      });
      this.produto.quantidade = qtd_geral;
      this.produto.subtotal = qtd_geral * this.produto.valor;
    },
    editarProduto(produto) {
      this.produto_index = this.pedido.produtos.indexOf(produto);
      this.produto = this.clone(produto);
      this.$refs.dialogoProdutos.abrir();
    },
    fecharDialogoProdutos() {
      this.produto_index = -1;
      this.produto = {
        tamanhos: [],
        cores: [],
        observacoes: "",
        valor: 0,
      };
      this.$refs.dialogoProdutos.fechar();
    },
    abrirDialogoExcluir(produto) {
      this.produto_index = this.pedido.produtos.indexOf(produto);
      this.$refs.dialogoExcluirProduto.abrir();
    },
    excluirProduto() {
      this.pedido.produtos.splice(this.produto_index, 1);
      this.pedido.quantidade = this.quantidadeGeral;
      this.pedido.valor_bruto = this.valorGeral;
      this.calcularDescontoValor();
      this.calcularTaxaValor();
      this.calcularValorLiquido();
      this.fecharDialogoExcluir();
    },
    fecharDialogoExcluir() {
      this.produto_index = -1;
      this.$refs.dialogoExcluirProduto.fechar();
    },
    calcularValorLiquido() {
      this.pedido.valor_liquido =
        this.pedido.valor_bruto -
        this.pedido.desconto_valor +
        this.pedido.taxa_valor;

      this.pedido.comissao_valor =
        (this.pedido.valor_liquido * this.pedido.comissao_percentual) / 100;
    },
    calcularDescontoValor() {
      if (this.pedido.desconto_percentual) {
        this.pedido.desconto_valor =
          (this.pedido.valor_bruto * this.pedido.desconto_percentual) / 100;
      } else {
        this.pedido.desconto_valor = 0;
        this.pedido.desconto_percentual = 0;
      }
      this.calcularValorLiquido();
    },
    calcularDescontoPercentual() {
      if (this.pedido.desconto_valor) {
        this.pedido.desconto_percentual =
          (this.pedido.desconto_valor / this.pedido.valor_bruto) * 100;
      } else {
        this.pedido.desconto_percentual = 0;
        this.pedido.desconto_valor = 0;
      }
      this.calcularValorLiquido();
    },
    calcularTaxaValor() {
      if (this.pedido.taxa_percentual) {
        this.pedido.taxa_valor =
          (this.pedido.valor_bruto * this.pedido.taxa_percentual) / 100;
      } else {
        this.pedido.taxa_valor = 0;
        this.pedido.taxa_percentual = 0;
      }
      this.calcularValorLiquido();
    },
    calcularTaxaPercentual() {
      if (this.pedido.taxa_valor) {
        this.pedido.taxa_percentual =
          (this.pedido.taxa_valor / this.pedido.valor_bruto) * 100;
      } else {
        this.pedido.taxa_percentual = 0;
        this.pedido.taxa_valor = 0;
      }
      this.calcularValorLiquido();
    },
    recuperarPedido() {
      this.pedido = JSON.parse(localStorage.getItem("pedido"));
      this.$refs.dialogoPedidoAberto.fechar();
    },
    cancelarRecuperacaoPedido() {
      localStorage.removeItem("pedido");
      this.$refs.dialogoPedidoAberto.fechar();
    },
    salvarPedidoStorage() {
      if (
        JSON.stringify(pedidoBlank) !==
        JSON.stringify({
          ...this.pedido,
          uuid: undefined,
          data: "",
          rodada_id: undefined,
        })
      ) {
        localStorage.setItem("pedido", JSON.stringify(this.pedido));
      }
    },
    async salvarPedido() {
      try {
        if (this.$refs.form.validate()) {
          this.loading = true;

          let rodada_id = this.$store.state.rodadaSetada
            ? this.rodada.id
            : null;
          let fornecedor_id = this.pedido.fornecedor_id;
          if (this.user.tipo == "fornecedor") {
            fornecedor_id = this.user.fornecedor_id;
          }

          let pedido_salvar = {
            ...this.pedido,
            cliente_id: this.pedido.cliente.cliente.id,
            cliente_loja_id: this.pedido.cliente.id,
            fornecedor_id: fornecedor_id,
            representante_id: this.pedido.cliente.cliente.representante_id,
            rodada_id: rodada_id,
          };

          if (this.$route.meta.status == "novo") {
            await ServicePedidos.salvar(pedido_salvar);
            this.$eventbus.notificar("Pedido salvo com sucesso");
          } else if (this.$route.meta.status == "editar" && !pedido_salvar.id) {
            await ServicePedidos.salvar(pedido_salvar);
            this.$eventbus.notificar("Pedido salvo com sucesso");
          } else if (this.$route.meta.status == "editar") {
            await ServicePedidos.atualizar(
              this.$route.params.id,
              pedido_salvar
            );
            this.$eventbus.notificar("Pedido atualizado com sucesso");
          } else if (this.$route.meta.status == "copiar") {
            delete pedido_salvar.id;

            await ServicePedidos.salvar(pedido_salvar);
            this.$eventbus.notificar("Pedido salvo com sucesso");
          }

          localStorage.removeItem("pedido");
          this.$router.push("/pedidos");
        }
      } catch (error) {
        this.$eventbus.erro("Erro ao salvar pedido");
      } finally {
        this.loading = false;
      }
    },
    cancelarPedido() {
      localStorage.removeItem("pedido");
      this.$router.push("/pedidos");
    },
    async editar(pedido_id, uuid) {
      try {
        this.loading_edit = true;
        let pedido;

        if (
          /^[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}$/.test(
            pedido_id
          )
          // && localStorage.getItem("offLine")
        ) {
          pedido = await loadPedidoFromCache(uuid);
        } else {
          pedido = await ServicePedidos.editar(pedido_id, uuid);
        }

        this.pedido = pedido.data.pedido;
        this.pedido.cliente.representante_nome =
          (this.pedido.representante &&
            this.pedido.representante.nome_fantasia) ||
          this.pedido.cliente.representante_nome;

        if (this.$route.meta.status == "copiar") {
          this.pedido.data = this.data_atual;
          this.pedido.uuid = uuidv4();
        }
      } catch (error) {
        this.$eventbus.erro("Erro ao editar este pedido");
      } finally {
        this.loading_edit = false;
      }
    },
    abrirDialogoObservacoes() {
      this.$refs.dialogoObservacoes.abrir();
      setTimeout(() => {
        this.$refs.observacao_produto.focus();
      }, 800);
    },
    async getDataAtual() {
      this.data_atual =
        new Date().getFullYear() +
        "-" +
        String(new Date().getMonth() + 1).padStart(2, "0") +
        "-" +
        String(new Date().getDate()).padStart(2, "0");
      this.pedido.data = this.data_atual;
      let data_atual = await ServicePedidos.getDataAtual();
      this.data_atual = data_atual.data.data_atual || this.data_atual;
      if (this.$route.meta.status == "novo" && data_atual.data.data_atual) {
        this.pedido.data = data_atual.data.data_atual;
      }
    },
  },
  computed: {
    quantidadeGeral() {
      let qtd_total = 0;

      qtd_total = this.pedido.produtos.reduce((soma, produto) => {
        return soma + produto.quantidade;
      }, 0);

      return qtd_total;
    },
    valorGeral() {
      let valor_total = 0;

      valor_total = this.pedido.produtos.reduce((soma, produto) => {
        return soma + produto.subtotal;
      }, 0);

      return valor_total;
    },
    salvarDisabled() {
      // if (this.pedido.cliente.id && this.pedido.produtos.length > 0 && this.form_valid) {
      if (this.pedido.cliente.id && this.pedido.produtos.length > 0) {
        return false;
      } else {
        return true;
      }
    },
    titulo() {
      if (this.$route.meta.status == "novo") {
        return "Novo Pedido";
      } else if (this.$route.meta.status == "editar") {
        return "Editar Pedido " + this.$route.params.id;
      } else if (this.$route.meta.status == "copiar") {
        return "Copiar Pedido " + this.$route.params.id;
      }
      return null;
    },
  },
  watch: {
    pedido: {
      handler: function() {
        this.salvarPedidoStorage();
      },
      deep: true,
    },
  },
};
</script>

<style>
.zui-table {
  border: none;
  border-right: solid 1px #ddefef;
  border-collapse: separate;
  border-spacing: 0;
  font: normal 13px Arial, sans-serif;
}
.zui-table thead th {
  background-color: lightgray !important;
  border: none;
  color: black !important;
  padding: 10px;
  text-align: left;
  white-space: nowrap;
  text-align: center;
  min-width: 100px;
  max-width: 100px;
}
.zui-table tbody td {
  border-bottom: solid 1px #ddefef;
  color: #333;
  padding: 10px;
  text-shadow: 1px 1px 1px #fff;
  white-space: nowrap;
}
.zui-wrapper {
  position: relative;
}
.zui-scroller {
  overflow-x: scroll;
  overflow-y: visible;
  padding-bottom: 5px;
  /* width: 600px; */
}
.zui-table .zui-sticky-col {
  border-left: solid 1px #ddefef;
  border-right: solid 1px #ddefef;
  left: 0;
  position: sticky;
  top: auto;
  background-color: white;
}
.row-pointerPedido >>> tbody tr :hover {
  cursor: pointer;
}
</style>
